export default __webpack_public_path__ + "static/why_choose_game-82ede74dc37adb103a2c15183f8a387f.webp";